<template>
    <div v-if="body_show" class="he-review-box">
        <ul class="he-review">
            <li>
                <img :src="data.headimgurl" >
                <div>嗨，我正在做《职业发展健康指数测评》，很想知道在你眼中我的突出优势能力有哪些。请帮我真实的评价一下吧，这对于我更好的了解自己特别重要，非常感谢~</div>
            </li>
            <li>
                <img :src="data.headimgurl" >
                <div>另，这个评价为匿名评价，会与其他评价一起形成我的能力优势图，评价完成后，你也可以免费获得一次《职业发展健康指数测评》，帮你更好的了解当下的职业状态，还蛮有意思，可以试试看：）</div>
            </li>
        </ul>
        <router-link class="to-review" :to="{
            path:'/evaluation_name',
            query:{
                cid:this.$route.query.cid,
                uid:this.$route.query.uid
            }
        }" >
            为我评价
        </router-link>
    </div>
</template>

<script>
import { gettitle } from "@/api/measurement";
import { shareCon } from "@/utils/wxconfig";
export default {
    data() {
      return {
        data: {},
        body_show: false
      }
    },
    methods: {
      pullData() {
        let cid = this.$route.query.cid;
        gettitle({
            cid: cid,
            uid:this.$route.query.uid
          })
          .then((data) => {
            this.body_show = true;
            document.title = data.headtitle;
            this.data = data;
          })

      }
    },
    created() {
      this.pullData();
      shareCon("measurement",this);
    }
}
</script>

<style lang="scss" scoped>
    .he-review-box{
        .to-review{
            display: block;
            text-align: center;
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            line-height: 98px;
            background-color: #EB5032;
            color: #fff;
            border: none;
            font-size:34px;
        }
        .he-review{
            padding: 40px 30px 98px 30px;
        }
        .he-review li{
            font-size: 0;
            margin-bottom: 60px;
            img{
                display: inline-block;
                width: 70px;
                height: 70px;
                border-radius: 50%;
                vertical-align: top;
            }
            div{
                display: inline-block;
                width:520px;
                background:#F57F17;
                border-radius:8px;
                padding: 20px;
                line-height: 42px;
                color: #FFFFFF;
                font-size: 26px;
                margin-left: 28px;
                position: relative;
            }
            div:after{
                content: '';
                width: 0;
                height: 0;
                position: absolute;
                top: 20px;
                left: -14px;
                border-top: 10px solid rgba(245, 127, 23, 0);
                border-right: 15px solid rgba(245, 127, 23, 1);
                border-bottom: 10px solid rgba(245, 127, 23, 0);
            }
        }
    }
</style>
